/**
 * Plain-language copy for the shared consumer provider list on the Stockholm
 * site. Passed to `<ProviderList copy={...} />` so Stockholm reads as a
 * consumer guide ("utförare", "Kommunal eller privat") while the other
 * municipality sites keep the shared defaults.
 */
export const STOCKHOLM_LIST_COPY = {
  providerNoun: "Utförare",
  providerNounPlural: "Utförare",
  providerNounPluralLower: "utförare",
  searchPlaceholder: "Sök utförare…",
  continuityAverageLabel: "Snitt olika personer (14 dagar)",
  coverageUnitNoun: "utförare",
  hideScrapedCount: true,
  regiFilterLabel: "Kommunal eller privat",
  regiFilterAllLabel: "Alla",
};
